import jQuery from 'jquery';

function isEmpty(something) {
    return jQuery.isEmptyObject(something);
}

function cp(something) {
    if (Array.isArray(something)) {
        return jQuery.extend(true, [], something);
    } else if ('object' === typeof(something) && null !== something) {
        return jQuery.extend(true, {}, something);
    }
    // if (Array.isArray(something) || ('object' === typeof(something) && null !== something)) {
    //     return JSON.parse(JSON.stringify(something));
    // }
    return something;
}

/**
 *
 * @param a
 * @param b
 * @returns {array}
 */
function arrayDiff(a, b) {
    return a.filter(value => b.indexOf(value) < 0);
}

/**
 *
 * @param a
 * @param b
 * @returns {*}
 */
function arrayDuplicates(a, b) {
    return a.filter(value => b.includes(value));
}

/**
 *
 * @param arr
 * @returns {*}
 */
function arrayUnique(arr) {
    return arr.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}

/**
 *
 * @param arr
 * @param deletableValues
 * @returns {*}
 */
function arrayRemoveValues(arr, deletableValues) {
    deletableValues = Array.isArray(deletableValues) ? deletableValues : [deletableValues];

    return arr.filter((value) => !inArray(value, deletableValues));
}

function indexArray(arr, propName) {
    const dictionary = {};
    arr.map(item => {
        if (item.hasOwnProperty(propName)) {
            dictionary[item[propName]] = item;
        }
    });
    return dictionary;
}

/**
 *
 * @param value
 * @param arr
 * @returns {boolean}
 */
function inArray(value, arr) {
    return -1 !== arr.indexOf(value);
}

/**
 *
 * @param arr
 * @returns {{next: (function(): next), valid: (function(): boolean), key: (function(): number), current: current, rewind: (function(): rewind), setKey: setKey}}
 */
function makeIterator(arr) {

    var index = 0;

    return {
        next: function () {
            index++;
            return this;
        },
        valid: function () {
            return index < arr.length;
        },
        key: function () {
            return index;
        },
        current: function (defaultValue = null) {
            if (this.valid()) {
                return arr[index];
            }
            return defaultValue;
        },
        rewind: function () {
            index = 0;
            return this;
        },
        setKey: function (key) {
            index = key;
        }
    };
}

function initTabs(){
    jQuery('body').on('click', '.results-aside .table-tab a', function () {
        var prefix = jQuery(this).attr('href').substr(1);

        jQuery('.results-aside .table-tab li').removeClass('active');
        jQuery('.tab-content').removeClass('show');

        jQuery(this).parent('li').addClass('active');
        jQuery('.' + prefix + '-content').addClass('show');
        return false;
    })
}

jQuery(function() {
    initTabs();

    jQuery('body').on('click', '.filters-table-opener', function() {
        jQuery(this).closest('.filters-table').toggleClass('close-filter');
    });
});

if (typeof window !== 'undefined') {
    window.isEmpty = isEmpty;
    window.cp = cp;
    window.arrayDiff = arrayDiff;
    window.arrayDuplicates = arrayDuplicates;
    window.arrayUnique = arrayUnique;
    window.arrayRemoveValues = arrayRemoveValues;
    window.indexArray = indexArray;
    window.inArray = inArray;
    window.makeIterator = makeIterator;
    window.initTabs = initTabs;
}
